
export function useHtmlMetaFunc() {

  function setTitle(title?:string | unknown): void {
    if ( title ) {
      const setTitle = title + ' | OKASHOP';
      document.title = setTitle;
    } else {
      document.title = 'OKASHOP'
    }
  }

  function setDescription(description?: string | unknown): void {
    if ( description ) {
      const setDesc = description + 'OKASHOP';
      document.querySelector("meta[name='description']")?.setAttribute('content', setDesc)
    } else {
      //ignore
    }
  }

  return {
    setTitle,
    setDescription,
  }
}
